export const contextApiBaseUrl = process.env.NODE_ENV === "development REMOVEME" ? "http://localhost:3001" : "https://api.getcontextnow.com";